import { MarkdownRenderer } from '@/markdown/renderer';
import type { OverviewEchoContext } from '@/types/widget';

export interface OverviewEchoBubbleProps {
  context: OverviewEchoContext;
}

export function OverviewEchoBubble({ context }: OverviewEchoBubbleProps): JSX.Element {
  return (
    <section className="tw-rounded-md tw-border tw-border-cal-green-100 tw-bg-cal-green-50 tw-p-3 tw-text-sm tw-text-cal-green-900">
      <div className="tw-text-xs tw-text-cal-green-700 tw-mb-2">
        Depuis votre recherche : <span className="tw-italic">{context.query}</span>
      </div>
      {context.result.match ? (
        <>
          <div className="tw-font-semibold tw-mb-1">{context.result.product_title}</div>
          {context.result.response
            .split(/\n\n+/)
            .filter((p) => p.trim())
            .map((p, i) => (
              <p key={i} className="tw-leading-relaxed tw-mb-2">
                {p}
              </p>
            ))}
        </>
      ) : (
        <MarkdownRenderer source={context.result.fallback_message} />
      )}
    </section>
  );
}
